import { ref } from 'vue';
import ModalWrapper from '../ModalWrapper.vue';

export function useModalWrapper() {
  const isVisible = ref(false);
  const modalRef = ref<InstanceType<typeof ModalWrapper> | null>(null);

  function show() {
    modalRef.value?.show();
  }
  function hide() {
    modalRef.value?.hide();
  }

  return { isVisible, show, hide, modalRef };
}
